<ejs-dialog #editProductAssetDialog [isModal]="true" [showCloseIcon]="true" [visible]="false" (close)="onCancel()"
  (open)="onOpen($event)">
  <ng-template #header>
    {{'i18n.domain.assets.product-assets.edit-asset.assign-asset' | translate}}
  </ng-template>

  <ng-template #content>
    @if (assetUploadEditorForm) {
      <app-asset-edit-tab-group #assetEditTabGroupComponent
                                [assetUploadEditorForm]="assetUploadEditorForm"
                                (setScreenSize)="setScreenSize($event)">
      </app-asset-edit-tab-group>
    }
  </ng-template>

  <ng-template #footerTemplate>
    <ng-container>
      <button class="e-control e-btn e-lib e-flat" (click)="onCancel()">
        {{'i18n.shared.cancel' | translate}}
      </button>
      <button class="e-control e-btn e-lib e-primary e-flat" (click)="onSave()">
        {{'i18n.shared.save' | translate}}
      </button>
    </ng-container>
  </ng-template>
</ejs-dialog>
